const stopPropagation = (event) => event.stopPropagation();

export { stopPropagation };
